/// <reference path="./newsLetterSignUpFullForm.ts" />

namespace ekh {

    export class NewsLetterSignUpPopupForm extends ekh.NewsLetterSignUpFullForm {
        private onSuccess: () => any;
        constructor(
            protected resourceService: Core.ResourceService,
            protected $location: ng.ILocationService,
            protected analytics: any,
            protected $scope: ng.IScope,
            protected $timeout: ng.ITimeoutService
        ) {
         super(resourceService, $location, analytics, $scope, $timeout);
         this.showExtended = true;
         this.signUpReason = 'Newsletters Signup pop up';
         this.subscribePrimaryButtonLabel = 'NEWSLETTERSIGNUPPOPUPSUBSCRIBEBUTTON';
        }

        _getGaTrackData() {
            const page = this.$location.path();
            return {
                category: 'newsletterSignup',
                action: 'signedUp_PopUp',
                label: page,
                dimension9: 'newsletterSignup'
            };        }

        public submit() {
            const data = this._getData();
            this.$scope.formState.resetSubmitResult();
            return this.$scope.formState.submit(data)
                .then(() => {
                    if (TRPCONFIG.Domain.TrackNewsletterSignup) {
                        this.analytics.trackEvent(this._getGaTrackData());
                    }
                    this.onSuccess();
                });
        }

    }

    angular
        .module('ekh')
        .directive('newsletterSignUpPopupForm', function(authService) {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'partials/home/directivetemplate?type=newslettersignupfullform',
                controllerAs: 'nsu',
                bindToController: {
                    allowUnsubscribe: '=',
                    onSuccess: '&',
                    primaryButton: '='
                },
                scope: {
                },
                link: ($scope) => {
                    $scope.formState.setSubmitFn(data => {
                        return authService
                            .registerForNewsletter(data);
                    });
                },
                controller: NewsLetterSignUpPopupForm
            };
        });
}
